import { Component, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from 'environments/environment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  constructor(private router: Router) { }
  hostname=environment.hostname;
  user_details:any;
  company_name: string='';

  dashboardItems = [
    { title: 'CxO.Suite', icon: '../../assets/img/employees-icon.png', path:"#", description: 'Human Resources Management' },
    { title: 'Central.Hub', icon: '../../assets/img/accounting-icon.png', path:"/centralhubdashboard", description: 'Accounts, Compliance & Audit' },
    { title: 'Insight.Integrator', icon: '../../assets/img/insight-icon.png', path:"#", description: 'Business Intelligence and Analytics' },
    { title: 'People.Pulse', icon: '../../assets/img/employees-icon.png', path:"/peoplepulse", description: 'Human Resources Management' },
    { title: 'Retail.Radius', icon: '../../assets/img/retail-icon.png', path:"#", description: 'Retail Management' },
    { title: 'Customer.Connector', icon: '../../assets/img/customer-icon.png', path:"#", description: 'Customer Relationship Management' },
    { title: 'Stock.Sphere', icon: '../../assets/img/inventory-icon.png', path:"/stocksphere", description: 'Inventory Management' },
    { title: 'Supply.Sync', icon: '../../assets/img/supply-icon.png', path:"/supplysync", description: 'Supply Chain Management' },
    { title: 'Asset.Anchor', icon: '../../assets/img/asset-icon.png', path:"#", description: 'Fixed Asset Management' },
    { title: 'Service.Spectrum', icon: '../../assets/img/service-icon.png', path:"#", description: 'After-Sales Service and Support' },
    { title: 'Super Admin', icon: '../../assets/img/settings-icon.png', path:'/superadmin' },
  ];

  ngOnInit() {
    let user_details = localStorage.getItem('data');
    let company_name= localStorage.getItem('companyname');
    this.company_name= company_name;
    if (user_details) {
      try {
        this.user_details = JSON.parse(user_details);
        console.log('Parsed data from localStorage:', this.user_details);
        // You can now use parsedData as needed
      } catch (error) {
        console.error('Error parsing JSON from localStorage:', error);
      }
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('data');
    localStorage.removeItem('accesslist');

    // const targetOrigin = `http://pramaat1.com/#/login`;
    window.location.href = `${environment.centralDomainUrl}/#/login`;
    // const targetWindow = window.open(targetOrigin);
    // this.router.navigate(['/login']);
    // window.location.reload();
}

gotolandingpage(){
  // const targetOrigin = `http://pramaat1.com/#/login-dashboard`;
  window.location.href = `${environment.centralDomainUrl}/#/login-dashboard`;
  // const targetWindow = window.open(targetOrigin);
  // this.router.navigate(['/login']);
}

  onClick(item: any) {
    return this.router.navigate([item]);
  }
}
